import styled from '@emotion/styled';
import { useReturnCancelCount } from 'hooks/business/openReturnStatus';
import React from 'react';
import { platformLabelMap } from 'services/config/platform';
import toLowerCase from 'utils/toLowerCase';

const Container = styled.div`
  display: flex;
  background: var(--fett-bg-panel);
  padding: 12px 16px;
  gap: 24px;
  border-bottom: 1px solid var(--fett-border-default);
`;
const Platform = styled.div<{ active: string }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 100%;
  > img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
  > span {
    font-size: 14px;
    font-weight: 500;
    color: ${({ active }) =>
      active === 'true' ? 'var(--ant-primary-color)' : 'var(--fett-text-tertiary)'};
  }
`;

interface Props {
  platforms: Exclude<General.PlatformUpperCase, 'TOKOPEDIA'>[];
  active: General.PlatformUpperCase;
  setActive: (platform: General.PlatformUpperCase) => void;
}
const PlatformTab = React.memo((props: Props) => {
  const { platforms, active, setActive } = props;
  const returnCancelCount = useReturnCancelCount();

  return (
    <Container>
      {platforms.map((item) => {
        let totalCount = returnCancelCount.shopeeTotalCount;
        if (item === 'LAZADA') {
          totalCount = returnCancelCount.lazadaTotalCount;
        } else if (item === 'TIKTOK') {
          totalCount = returnCancelCount.tiktokTotalCount;
        } else if (item === 'TIKTOK_US') {
          totalCount = returnCancelCount.tiktokUsTotalCount;
        } else if (item === 'MERCADO') {
          totalCount = returnCancelCount.mercadoTotalCount;
        } else if (item === 'KWAI') {
          totalCount = returnCancelCount.kwaiTotalCount;
        }

        return (
          <Platform active={String(item === active)} onClick={() => setActive(item)} key={item}>
            <span>
              {platformLabelMap[toLowerCase(item)]}({totalCount})
            </span>
          </Platform>
        );
      })}
    </Container>
  );
});

export default PlatformTab;
